import type { ReactNode } from "react";
import { useDayData } from "@/hooks/useDayData";
import type { DayData } from "@/types/lex";

interface DayLoaderProps {
  day: number;
  /** Optional override of the loading skeleton. */
  loadingFallback?: ReactNode;
  children: (data: DayData) => ReactNode;
}

/**
 * Render-prop wrapper around `useDayData`. Keeps screens free of
 * loading / error boilerplate.
 */
export function DayLoader({ day, loadingFallback, children }: DayLoaderProps) {
  const state = useDayData(day);

  if (state.status === "loading") {
    return (
      loadingFallback ?? (
        <div className="container" style={{ paddingTop: "var(--s-8)" }}>
          <div className="empty">Loading day {day}…</div>
        </div>
      )
    );
  }

  if (state.status === "error") {
    return (
      <div className="container" style={{ paddingTop: "var(--s-8)" }}>
        <div className="empty" style={{ borderColor: "var(--accent-red)", color: "var(--accent-red)" }}>
          Could not load Day {day}. {state.error.message}
        </div>
      </div>
    );
  }

  return <>{children(state.data)}</>;
}
